import { JSX } from "react";

import { VMLanguages } from "@4pace-cpq/core";
import { FormControl, MenuItem, Select } from "@mui/material";

interface IFlags {
  [key: string]: string;
}

export function LanguageSelect({
  languages,
  selectedLanguageId,
  onChange,
}: {
  languages: VMLanguages[];
  selectedLanguageId: VMLanguages["id"] | null | undefined;
  onChange: (selectedLanguageId: VMLanguages["id"]) => void;
}): JSX.Element {
  const flags: IFlags = {
    "en-US": "🇺🇸",
    "de-DE": "🇩🇪",
    "da-DK": "🇩🇰",
    "es-ES": "🇪🇸",
    "fr-FR": "🇫🇷",
    "hu-HU": "🇭🇺",
    "it-IT": "🇮🇹",
    "nl-NL": "🇳🇱",
    "pl-PL": "🇵🇱",
    "pt-BR": "🇧🇷",
    "pt-PT": "🇵🇹",
    "ro-RO": "🇷🇴",
    "ru-RU": "🇷🇺",
    "sk-SK": "🇸🇰",
    "sl-SI": "🇸🇮",
    "sv-SE": "🇸🇪",
    "zh-CN": "🇨🇳",
    "lt-LT": "🇱🇹",
    "tr-TR": "🇹🇷",
    "vi-VN": "🇻🇳",
  };
  const sortedLanguages = languages.sort((a, b) => {
    if (!a.languageCode || !b.languageCode) {
      return 0;
    }
    if (a.languageCode < b.languageCode) {
      return -1;
    }
    if (a.languageCode > b.languageCode) {
      return 1;
    }
    return 0;
  });

  return (
    <FormControl>
      <Select<VMLanguages["id"]>
        value={selectedLanguageId || ""}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        sx={{
          ">.MuiSelect-select": {
            py: 0,
            pl: 2,
            pr: 4,
            fontSize: "1.25em",
            lineHeight: "1.5em",
          },
          ">fieldset": {
            border: "none",
          },
        }}
      >
        {sortedLanguages?.map((language) =>
          language.languageCode &&
          Object.keys(flags).includes(language.languageCode) ? (
            <MenuItem
              key={language.id}
              value={language.id}
              sx={{ fontSize: "1.25em" }}
            >
              {language.languageCode && flags[language.languageCode]
                ? flags[language.languageCode]
                : language.languageCode}
            </MenuItem>
          ) : null,
        )}
      </Select>
    </FormControl>
  );
}

export default LanguageSelect;
